import { gql } from '@apollo/client'
import { IContactUs, IRecaptchaToken, ISendEmailToDealerGQL } from 'src/interface'
import { dispatchMutationGQL } from '../../gqlActions'

const SEND_EMAIL_TO_DEALER = gql`
  mutation SendEmailToDealer(
    $userInfo: UserInfo!
    $productInfo: String!
    $dealersToSendEmail: [Dealer!]!
    $comments: String
    $country: String!
    $state: String
    $organization: String!
    $recaptchaToken: String!
  ) {
    sendEmailToDealer(
      userInfo: $userInfo
      productInfo: $productInfo
      dealersToSendEmail: $dealersToSendEmail
      comments: $comments
      country: $country
      state: $state
      organization: $organization
      recaptchaToken: $recaptchaToken
    )
  }
`

const SEND_EMAIL_TO_TRAINING = gql`
  mutation SendEmailTraining(
    $userInfo: UserInfo!
    $productInfo: String!
    $comments: String
    $country: String!
    $state: String!
    $organization: String!
    $recaptchaToken: String!
  ) {
    sendEmailTraining(
      userInfo: $userInfo
      productInfo: $productInfo
      comments: $comments
      country: $country
      state: $state
      organization: $organization
      recaptchaToken: $recaptchaToken
    )
  }
`

/**
 * Sends request to /sold endpoint and dispatch an event. If error, dipatch an event error
 * @param userInfo - The user information.
 * @param {string} productInfo - product name.
 * @param {string} comments - User comments on the form.
 * @returns status code
 */
export const sendEmailToDealerGQL = async ({
  userInfo,
  productInfo,
  dealersToSendEmail,
  comments,
  country,
  state,
  organization,
  recaptchaToken
}: ISendEmailToDealerGQL) => {
  return await dispatchMutationGQL({
    mutation: SEND_EMAIL_TO_DEALER,
    variables: { userInfo, productInfo, dealersToSendEmail, comments, country, state, organization, recaptchaToken },
    key: 'sendEmailToDealer'
  })
}

/**
 * Sends request to /training endpoint, dispatch an event and return status code. If error, dipatch an event error
 * @param userInfo - The user information.
 * @param {string} productInfo - product name.
 * @param {string} comments - User comments on the form.
 * @returns status code
 */
export const sendEmailToTrainingGQL = (
  userInfo: IContactUs,
  productInfo: string,
  comments: string,
  country: string,
  state: string,
  organization: string,
  recaptchaToken: IRecaptchaToken
) => {
  return dispatchMutationGQL({
    mutation: SEND_EMAIL_TO_TRAINING,
    variables: { userInfo, productInfo, comments, country, state, organization, recaptchaToken },
    key: 'sendEmailToTraining'
  })
}
